export interface FieldOption {
  value: string | boolean;
  label_ru: string;
  label_en: string;
}

export interface SourceField {
  name: string;
  type: 'text' | 'tel' | 'promo' | 'buttons' | 'select';
  required: boolean;
  label_ru: string;
  label_en: string;
  options?: FieldOption[];
  loadOptions?: string;
  showIf?: {
    field: string;
    value: string | boolean;
  };
}

export interface SourceConfig {
  fields: SourceField[];
}

export const SOURCE_FIELDS: Record<string, SourceConfig> = {
  call_messenger: {
    fields: [
      { name: 'phone', type: 'tel', required: true, label_ru: 'Телефон', label_en: 'Phone' },
      { name: 'customer_name', type: 'text', required: true, label_ru: 'Имя', label_en: 'Name' },
      { name: 'promo_code', type: 'promo', required: false, label_ru: 'Промокод', label_en: 'Promo Code' },
      {
        name: 'payment_type',
        type: 'buttons',
        required: true,
        label_ru: 'Оплата',
        label_en: 'Payment',
        options: [
          { value: 'cash', label_ru: 'Наличные', label_en: 'Cash' },
          { value: 'card', label_ru: 'Карта', label_en: 'Card' },
          { value: 'transfer', label_ru: 'Перевод', label_en: 'Transfer' },
        ]
      },
      {
        name: 'delivery_type',
        type: 'buttons',
        required: true,
        label_ru: 'Доставка',
        label_en: 'Delivery',
        options: [
          { value: 'delivery', label_ru: 'Доставка', label_en: 'Delivery' },
          { value: 'pickup', label_ru: 'Самовывоз', label_en: 'Pickup' },
        ]
      },
      {
        name: 'delivery_address',
        type: 'text',
        required: true,
        label_ru: 'Адрес доставки',
        label_en: 'Delivery Address',
        showIf: { field: 'delivery_type', value: 'delivery' }
      },
    ]
  },

  glovo: {
    fields: [
      { name: 'customer_name', type: 'text', required: true, label_ru: 'Имя', label_en: 'Name' },
      { name: 'order_number', type: 'text', required: true, label_ru: 'Номер заказа', label_en: 'Order Number' },
      {
        name: 'payment_type',
        type: 'buttons',
        required: true,
        label_ru: 'Оплата',
        label_en: 'Payment',
        options: [
          { value: 'online', label_ru: 'Онлайн', label_en: 'Online' },
          { value: 'cash', label_ru: 'Наличные', label_en: 'Cash' },
        ]
      },
      {
        name: 'delivery_type',
        type: 'buttons',
        required: true,
        label_ru: 'Доставка',
        label_en: 'Delivery',
        options: [
          { value: 'delivery', label_ru: 'Доставка', label_en: 'Delivery' },
          { value: 'pickup', label_ru: 'Самовывоз', label_en: 'Pickup' },
        ]
      },
      {
        name: 'delivery_address',
        type: 'text',
        required: true,
        label_ru: 'Адрес доставки',
        label_en: 'Delivery Address',
        showIf: { field: 'delivery_type', value: 'delivery' }
      },
    ]
  },

  wolt: {
    fields: [
      { name: 'customer_name', type: 'text', required: true, label_ru: 'Имя', label_en: 'Name' },
      { name: 'phone', type: 'tel', required: true, label_ru: 'Телефон', label_en: 'Phone' },
      { name: 'order_number', type: 'text', required: true, label_ru: 'Номер заказа', label_en: 'Order Number' },
      {
        name: 'payment_type',
        type: 'buttons',
        required: true,
        label_ru: 'Оплата',
        label_en: 'Payment',
        options: [
          { value: 'online', label_ru: 'Онлайн', label_en: 'Online' },
          { value: 'cash', label_ru: 'Наличные', label_en: 'Cash' },
        ]
      },
      {
        name: 'delivery_type',
        type: 'buttons',
        required: true,
        label_ru: 'Доставка',
        label_en: 'Delivery',
        options: [
          { value: 'delivery', label_ru: 'Доставка', label_en: 'Delivery' },
          { value: 'pickup', label_ru: 'Самовывоз', label_en: 'Pickup' },
        ]
      },
      {
        name: 'delivery_address',
        type: 'text',
        required: true,
        label_ru: 'Адрес доставки',
        label_en: 'Delivery Address',
        showIf: { field: 'delivery_type', value: 'delivery' }
      },
    ]
  },

  courier: {
    fields: [
      { name: 'customer_name', type: 'text', required: true, label_ru: 'Имя', label_en: 'Name' },
      {
        name: 'payment_type',
        type: 'buttons',
        required: true,
        label_ru: 'Оплата',
        label_en: 'Payment',
        options: [
          { value: 'cash', label_ru: 'Наличные', label_en: 'Cash' },
          { value: 'card', label_ru: 'Карта', label_en: 'Card' },
          { value: 'transfer', label_ru: 'Перевод', label_en: 'Transfer' },
        ]
      },
    ]
  },

  employee: {
    fields: [
      {
        name: 'employee_id',
        type: 'select',
        required: true,
        label_ru: 'Сотрудник',
        label_en: 'Employee',
        loadOptions: '/api/employees'
      },
    ]
  },
};

export const ORDER_SOURCES = [
  { value: 'call_messenger', label_ru: 'Звонок/Мессенджер', label_en: 'Call/Messenger' },
  { value: 'glovo', label_ru: 'Glovo', label_en: 'Glovo' },
  { value: 'wolt', label_ru: 'Wolt', label_en: 'Wolt' },
  { value: 'courier', label_ru: 'Курьер', label_en: 'Courier' },
  { value: 'employee', label_ru: 'Сотрудник', label_en: 'Employee' },
];
